export default __webpack_public_path__ + "static/media/baovietbank.53ef17a9.png";